import { ButtonLink } from "@kds-web/button";
import { ArrowUpIcon } from "@kds-web/icons";
import { useEffect, useState } from "react";
import type { JSX } from "react/jsx-runtime";
import { trackGAEvent } from "../../../../utils/google-analytics/tracking.ts";

interface ScrollToTopProps {
  originForTracking: string;
}

export function ScrollToTop({
  originForTracking,
}: ScrollToTopProps): JSX.Element {
  const [showScroll2Top, setShowScroll2Top] = useState(false);

  useEffect(() => {
    function handleButtonVisibility(): void {
      if (window.scrollY > 2 * window.innerHeight) {
        setShowScroll2Top(true);
      } else {
        setShowScroll2Top(false);
      }
    }

    window.addEventListener("scroll", handleButtonVisibility);
    return (): void => {
      window.addEventListener("scroll", handleButtonVisibility);
    };
  }, []);

  function scrollToTop(): void {
    setShowScroll2Top(false);
    trackGAEvent({
      eventCategory: originForTracking,
      eventAction: "ClickToTop",
    });
    window.scroll({ top: 0 });
  }

  return (
    <>
      {showScroll2Top && (
        <div className="fixed bottom-[20px] z-overlay ml-[720px]">
          <ButtonLink
            label="Nach oben"
            onClick={scrollToTop}
            iconLeft={<ArrowUpIcon />}
          />
        </div>
      )}
    </>
  );
}
